import { useEffect, useRef } from "react";
import DOMPurify from "dompurify";
import styles from "./PromotionModal.module.scss";
import { formatDate } from "../../../utils/formatDate";

const apiUrl = process.env.REACT_APP_API_URL;

function PromotionModal({ promotion, onClose }) {
  const dialogRef = useRef(null);

  console.log(promotion);

  useEffect(() => {
    if (!promotion) {
      return;
    }

    const dialog = dialogRef.current;

    if (!dialog || dialog.open) {
      return;
    }

    dialog.showModal();

    return () => {
      if (dialog.open) {
        dialog.close();
      }
    };
  }, [promotion]);

  if (!promotion) {
    return null;
  }

  const handleBackdropClick = (event) => {
    if (event.target === dialogRef.current) {
      onClose();
    }
  };

  const handleCancel = (event) => {
    // Empêche le navigateur de fermer directement le dialog.
    // On laisse le parent le démonter via onClose().
    event.preventDefault();
    onClose();
  };

  return (
    <dialog
      ref={dialogRef}
      className={styles.dialog}
      aria-labelledby="promotion-modal-title"
      onClick={handleBackdropClick}
      onCancel={handleCancel}
    >
      <div className={styles.header}>
        <h2 id="promotion-modal-title" className={styles.title}>
          {promotion.title}
        </h2>

        <button
          type="button"
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Fermer la promotion"
        >
          ×
        </button>
      </div>

      <div
        className={styles.content}
        style={{
          "--promotion-image": promotion.picture
            ? `url("${apiUrl}/uploads/${promotion.picture}")`
            : "none",
        }}
      >
        <p className={styles.entitled}>{promotion.entitled}</p>

        <div
          className={styles.description}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(promotion.description || ""),
          }}
        />

        <p className={styles.validity}>
          Offre valable jusqu'au {formatDate(promotion.end)}
        </p>
      </div>
    </dialog>
  );
}

export default PromotionModal;
